import {
  getWeatherStations,
  getWeatherStationsByGeolocation,
  //getWeatherStationSensorData,
  getWeatherStationHistoricalData,
  getHistoricalWeatherStationAverages,
  emailWeatherStationIssue,
} from '../../../apis/premier-plus-api';
import {handleApiError} from '../../../shared/actions';

export const initWeatherStations = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'INIT_WEATHER_STATIONS',
  });
  dispatch(fetchWeatherStations());
});

const getGeolocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'));
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }),
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              reject(new Error('User denied the request for Geolocation'));
              break;
            case error.POSITION_UNAVAILABLE:
              reject(new Error('Position update is unavailable'));
              break;
            case error.TIMEOUT:
              reject(new Error('The request to get user location timed out'));
              break;
            default:
              reject(new Error('An unknown error occurred'));
          }
        },
        {enableHighAccuracy: true, timeout: 5000, maximumAge: 0}
      );
    }
  });
};

export const toggleLocationBasedSorting = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'TOGGLE_LOCATION_BASED_SORTING',
  });
  dispatch(fetchWeatherStations());
});

export const fetchWeatherStations = () => (async (dispatch, getState) => {
  if (getState().weatherStations.locationEnabled === true) {
    try {
      const {latitude, longitude} = await getGeolocation();
      dispatch(fetchWeatherStationsByGeolocation(latitude, longitude));
    }
    catch (error) {
      alert('Your browser is denying access to your location. Make sure you allowed access to your location when prompted to by your browser. If you did not allow access when prompted, then you will have to reset the location permission in your browser.');
      dispatch(toggleLocationBasedSorting());
    }
  }
  else {
    dispatch(fetchWeatherStationsByDefaultSort());
  }
});

export const fetchWeatherStationsByDefaultSort = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_WEATHER_STATIONS',
  });
  var response = null;
  try {
    response = await getWeatherStations();
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_WEATHER_STATIONS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_WEATHER_STATIONS',
    weatherStations: response.body,
  });
});

export const fetchWeatherStationsByGeolocation = (latitude, longitude) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_WEATHER_STATIONS',
  });
  var response = null;
  try {
    response = await getWeatherStationsByGeolocation(latitude, longitude);
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_WEATHER_STATIONS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_WEATHER_STATIONS',
    weatherStations: response.body,
  });
});

export const userSelectedWeatherStation = (weatherStation, loadWeatherStationData) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_WEATHER_STATION',
    weatherStation: weatherStation,
  });
  if (loadWeatherStationData === true) {
    //dispatch(fetchWeatherStationSensorData());
    dispatch(fetchHistoricalWeatherData());
    dispatch(fetchWeatherStationHistoricalAverages());
  }
});

/*
export const fetchWeatherStationSensorData = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_WEATHER_STATION_SENSOR_DATA',
  });
  var response = null;
  try {
    response = await getWeatherStationSensorData(getState().weatherStations.selectedWeatherStation);
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_WEATHER_STATION_SENSOR_DATA_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_WEATHER_STATION_SENSOR_DATA',
    sensorData: response.body,
  });
});
*/

export const fetchHistoricalWeatherData = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_TO_FETCH_WEATHER_STATION_HISTORICAL_DATA',
  });
  const {
    selectedWeatherStation,
    historicalStartDate,
    historicalEndDate,
   } = getState().weatherStations;
  var response = null;
  try {
    response = await getWeatherStationHistoricalData(selectedWeatherStation, historicalStartDate, historicalEndDate);
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_WEATHER_STATION_HISTORICAL_DATA_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_WEATHER_STATION_HISTORICAL_DATA',
    historicalData: response.body,
  });
});

export const showWeatherStationModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'SHOW_WEATHER_STATION_MODAL',
  });
});

export const hideWeatherStationModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_WEATHER_STATION_MODAL',
  });
});

export const userSelectedHistoricalWeatherStartDate = (startDate) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_HISTORICAL_WEATHER_START_DATE',
    startDate: startDate,
  });
});

export const userSelectedHistoricalWeatherEndDate = (endDate) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_HISTORICAL_WEATHER_END_DATE',
    endDate: endDate,
  });
});

export const userSelectedWeatherStationDataPoint1 = (dataPoint) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_WEATHER_STATION_DATA_POINT1',
    dataPoint: dataPoint,
  });
});

export const userSelectedWeatherStationDataPoint2 = (dataPoint) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_WEATHER_STATION_DATA_POINT2',
    dataPoint: dataPoint,
  });
});

export const userSelectedWeatherStationDataPoint3 = (dataPoint) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_WEATHER_STATION_DATA_POINT3',
    dataPoint: dataPoint,
  });
});

export const setSelectedYear = (year) => ((dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_YEAR',
    year: year,
  });
});

export const fetchWeatherStationHistoricalAverages = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_WEATHER_STATION_HISTORICAL_AVERAGES',
  });
  var response = null;
  try {
    response = await getHistoricalWeatherStationAverages(getState().weatherStations.selectedWeatherStation.id, getState().weatherStations.selectedYear);
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_WEATHER_STATION_HISTORICAL_AVERAGES_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_WEATHER_STATION_HISTORICAL_AVERAGES',
    monthlyHistoricalAverages: response.body.monthlyHistoricalData,
    weeklyHistoricalAverages: response.body.weeklyHistoricalData,
  });
});

export const showReportWeatherStationModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'SHOW_REPORT_WEATHER_STATION_MODAL',
    customerName: getState().auth.authorization?.agvanceUser?.firstName + ' ' + getState().auth.authorization?.agvanceUser?.lastName
  });
});

export const hideReportWeatherStationModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_REPORT_WEATHER_STATION_MODAL',
  });
});

export const setWeatherStationIssueCustomerName = (customerName) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_WEATHER_STATION_ISSUE_CUSTOMER_NAME',
    customerName: customerName,
  });
});

export const setWeatherStationNameToReport = (stationName) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_WEATHER_STATION_NAME_TO_REPORT',
    stationName: stationName,
  });
});

export const setWeatherStationIssueToReport = (issue) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_WEATHER_STATION_ISSUE_TO_REPORT',
    issue: issue,
  });
});

export const submitWeatherStationIssue = () => (async (dispatch, getState) => {
  const {
    weatherStationIssueCustomerName,
    weatherStationNameToReport,
    weatherStationIssueToReport,
  } = getState().weatherStations;
  try {
    await emailWeatherStationIssue(weatherStationIssueCustomerName, weatherStationNameToReport, weatherStationIssueToReport);
  }
  catch (error) {
    dispatch(handleApiError(error));
  }
});
